import { render, staticRenderFns } from "./ViewBoard.vue?vue&type=template&id=66e98824"
import script from "./ViewBoard.vue?vue&type=script&lang=js"
export * from "./ViewBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports